exports.f = Object.getOwnPropertySymbols;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-gops.js
 ** module id = 963
 ** module chunks = 1
 **/